module.exports = __webpack_public_path__ + "static/media/arrow-down-dark.9fa54e3e.svg";